import { useState } from 'react'
import { authTexts } from '../auth.texts'

interface EmailStepProps {
  initialEmail: string
  onSubmit: (email: string) => void
  serverError: string | null
  isSubmitting: boolean
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const EmailStep = ({ initialEmail, onSubmit, serverError, isSubmitting }: EmailStepProps) => {
  const [email, setEmail] = useState(initialEmail)
  const [validationError, setValidationError] = useState<string | null>(null)
  const texts = authTexts.login

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const trimmed = email.trim().toLowerCase()
    if (!EMAIL_PATTERN.test(trimmed)) {
      setValidationError(texts.invalidEmail)
      return
    }
    setValidationError(null)
    onSubmit(trimmed)
  }

  const error = validationError ?? serverError

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6" noValidate>
      <div className="text-center">
        <h1 className="text-xl font-semibold text-foreground mb-2">{texts.title}</h1>
        <p className="text-sm text-muted">{texts.subtitle}</p>
      </div>

      <div className="flex flex-col gap-2">
        <label htmlFor="partner-email" className="text-sm font-medium text-foreground">
          {texts.emailLabel}
        </label>
        <input
          id="partner-email"
          type="email"
          autoComplete="email"
          inputMode="email"
          placeholder={texts.emailPlaceholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSubmitting}
          autoFocus
          className="w-full px-3 py-2.5 rounded-md border border-border bg-input text-foreground text-sm placeholder:text-muted focus:outline-none focus:border-primary focus:ring-2 focus:ring-ring/30 disabled:bg-disabled disabled:text-disabled-foreground transition-colors"
        />
      </div>

      {error && (
        <p className="text-sm text-error-text text-center" role="alert">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={isSubmitting || email.trim().length === 0}
        className="w-full py-2.5 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary-hover disabled:bg-disabled disabled:text-disabled-foreground transition-colors cursor-pointer disabled:cursor-not-allowed"
      >
        {isSubmitting ? texts.submitting : texts.submit}
      </button>
    </form>
  )
}
